export const HOTSPOT_STATUS = {
  DRAFT: "draft",
  CREATED: "created",
} as const;
